(function ($) {

	$.ZagParallax = function (element, options) {

		options = $.extend({}, $.ZagParallax.defaultOptions, options);

		if (options.image !== "") {

			const component = element;
			const background = `<div class="zag-parallax-bg" style="background-image: url(${options.image});"></div>`;
			const container = `<div class="zag-parallax-container">${background}</div>`;

			component.addClass("zag-parallax").prepend(container);
			ZagParallaxSet(component, options.divisor);

			$(window).on("resize scroll", function () {
				ZagParallaxSet(component, options.divisor);
			});
		}

	};

	function ZagParallaxSet(component, divisor) {

		var bg = component.find(".zag-parallax-bg");

		// parallax coverage is different for components that appear above vs. below the fold
		// if bottom of component is above the fold...
		var bgScale = component.offset().top + component.outerHeight() < $(window).height() ? component.offset().top : $(window).height() - component.outerHeight();
		var bgHeight = component.outerHeight() + bgScale / divisor
		var bgTop = ($(window).scrollTop() - component.offset().top) / divisor;

		bg.height(bgHeight);
		bg.css({ marginTop: bgTop });

	}

	$.fn.ZagParallax = (function (options) {
		return this.each(function () {
			(new $.ZagParallax($(this), options));
		});
	});

	$.ZagParallax.defaultOptions = { divisor: 1, image: "" };

})(jQuery);